import { render } from "./TemplateEditor.vue?vue&type=template&id=702653c5&scoped=true"
import script from "./TemplateEditor.vue?vue&type=script&lang=ts"
export * from "./TemplateEditor.vue?vue&type=script&lang=ts"

import "./TemplateEditor.vue?vue&type=style&index=0&id=702653c5&scoped=true&lang=scss"
import "./TemplateEditor.vue?vue&type=style&index=1&id=702653c5&lang=scss"
import "./TemplateEditor.vue?vue&type=style&index=2&id=702653c5&lang=scss"
script.render = render
script.__scopeId = "data-v-702653c5"

export default script